<div fxLayout="row wrap" fxLayoutAlign="space-between" class="border-bottom margin-bottom-20">
	<h5 class="arc-h5 margin-20" matDialogTitle>NAICS Code Selection</h5>
	<div class="col-sm-2 text-right">
		<app-close-mat-dialog (closeDialog)="dialogRef.close()"></app-close-mat-dialog>
	</div>
</div>

<mat-dialog-content class="mat-typography-custom-title min-width-400 border-bottom padding-top-10">
	<div class="col-sm-12 p-2"
	[ngClass]="{'add-naics-hint': lessThan()}">
		<mat-form-field class="col-sm-12 padding-left-0" appearance="outline">
			<mat-label>NAICS</mat-label>
			<input matInput
			placeholder="NAICS"
			[(ngModel)]="naicsCode"
			(ngModelChange) = changeInNaicsCode()
			id="naicsCode"
			[matAutocomplete]="naicsCodeAutocomplete"
		/>
		<mat-hint  *ngIf="lessThan()">
			Enter at least three digits to search NAICS code.
		</mat-hint>
	</mat-form-field>
		<mat-autocomplete autoActiveFirstOption	[displayWith]="displayNaicsCodeFunction" #naicsCodeAutocomplete="matAutocomplete">
					<mat-option  *ngFor="let naics of filteredCodeList" [value]="naics" >
						{{naics?.code}} - {{naics?.description}}
					</mat-option>
		</mat-autocomplete>
		<div role="status" class="sr-only" aria-live="polite">
			<span *ngIf="filteredCodeList?.length > 0"
				>There are {{ naicsCodeList?.length }} results available. Use the up and down arrows to navigate
				between options.</span
			>
			<span *ngIf="filteredCodeList?.length === 0">0 results available</span>
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center" class="margin-10 padding-0">
	<button type="button" mat-button color="primary" id="naics-cancel" class="margin-left-10 padding-0" [mat-dialog-close]="null">
		Cancel
	</button>
	<button
		type="button"
		[disabled]="!naicsCode"
		class="margin-left-right-20"
		color="primary"
		mat-flat-button
		id="naics-save"
		[mat-dialog-close]="naicsCode"
	>
		Save
	</button>
</mat-dialog-actions>
